import axios from '../../plugins/axios'

export const autocompleteRoom = (_, params) => {
  return axios.get('service/room/autocomplete/', { params })
    .then(response => ({ data: response.data, error: null }))
    .catch(error => ({ data: [], error }))
}
